import { HomePage } from "./home-page";

export const homeRoute = {
	path: "/",
	component: HomePage,
};
